import { useInfiniteQuery } from '@tanstack/react-query';

import { client } from '@/api/common';

import type { ChangelogCategory, ChangelogsPage } from './types';

export const useChangelogs = (category?: ChangelogCategory) => {
  return useInfiniteQuery({
    queryKey: ['internal/partners/changelogs', category],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await client.get('v2/internal/partners/changelogs', {
        params: {
          page: pageParam,
          per_page: 10,
          ...(category ? { category } : {}),
        },
      });

      return response.data as ChangelogsPage;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage: ChangelogsPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }

      return lastPage.meta.page + 1;
    },
  });
};
